"use client";

import { c as _c } from "react/compiler-runtime";
import HeaderSearchButton from "@/components/header/header-search/HeaderSearchButton";
import { Bars3Icon } from "@heroicons/react/24/outline";
import Image from "next/image";
import Link from "next/link";
interface SmallScreenHeaderProps {
  readonly onMenuToggle: () => void;
  readonly isMenuOpen: boolean;
}
export default function SmallScreenHeader(t0) {
  const $ = _c(6);
  const {
    onMenuToggle,
    isMenuOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Link href="/" className="tw-flex tw-items-center"><Image unoptimized={true} loading="eager" priority={true} alt="6529Seize" src="/6529.svg" className="tw-h-10 tw-w-10 tw-flex-shrink-0 tw-transition-all tw-duration-100 desktop-hover:hover:tw-scale-[1.02] desktop-hover:hover:tw-shadow-[0_0_20px_10px_rgba(255,215,215,0.3)]" width={40} height={40} /></Link>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HeaderSearchButton wave={null} />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isMenuOpen ? "Close menu" : "Open menu";
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Bars3Icon className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-iron-300" />;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== onMenuToggle || $[4] !== t3) {
    t5 = <header className="tailwind-scope tw-sticky tw-top-0 tw-z-50 tw-flex-shrink-0 tw-border-x-0 tw-border-b tw-border-t-0 tw-border-solid tw-border-iron-800 tw-bg-black"><div className="tw-flex tw-h-16 tw-items-center tw-justify-between tw-px-5">{t1}<div className="tw-flex tw-items-center tw-gap-3">{t2}<button onClick={onMenuToggle} className="tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-lg tw-border-0 tw-bg-iron-800 tw-text-iron-300 tw-shadow-sm tw-ring-1 tw-ring-inset tw-ring-iron-700 tw-transition tw-duration-300 tw-ease-out focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-primary-400 desktop-hover:hover:tw-bg-iron-700 desktop-hover:hover:tw-text-iron-50" aria-label={t3}>{t4}</button></div></div></header>;
    $[3] = onMenuToggle;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  return t5;
}